import styled from "styled-components";
import params from "../../global/params.json";

const containerParams = params.container;
export const Container = styled.div`
  z-index: 20;
  height: 88px;
  width: 100%;
  margin: 0 auto;
  align-self: center;
  position: fixed;
  display: flex;
  justify-content: center;
  background: ${(props) => props.bgcolor};
  transition: background 0.5s ease-in-out;
  .header {
    display: inline-block;
    max-width: ${containerParams.maxWHeaderDesktop};
    height: 90px;
    width: 100%;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .header-buttons {
    display: flex;
    align-items: center;
  }

  .navbar {
    &__desktop {
      ul {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 10px;
        gap: 4rem;
        list-style: none;
        li {
          a {
            color: black;
            text-decoration: none;
            font-size: 15px;
            transition: color 0.5s;
            font-weight: 600;
          }
        }
        li:hover {
          a {
            color: var(--secondaryColor);
          }
        }
      }
    }
    &__mobile {
      /* display: none; */
      background-color: white;
      position: absolute;
      top: -650px;
      left: -2px;
      right: -2px;
      opacity: 0;
      padding: 90px 20px 20px 20px;
      border-radius: 10px;
      transition: all 0.2s;
      z-index: -1;
      box-shadow: 1px 5px 50px rgba(0, 0, 0, 0.5);
      ul {
        list-style: none;
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .button {
          display: flex;
          align-items: center;
        }
        li {
          padding: 20px 20px;
          a {
            text-decoration: none;
            text-align: center;
            width: 100% !important;
            padding: 10px auto;
            color: black;
            font-size: 24px;
            font-weight: bold;
          }
        }
      }
    }
  }

  .mobile-button {
    display: none;
    background: transparent;
    border: none;
    img {
      height: 40px;
      color: black;
    }
  }
  @media screen and (max-width: 1280px) {
    .navbar {
      &__desktop {
        ul {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 0 10px;
          gap: 2.5rem;
          list-style: none;
        }
      }
    }
  }
  @media screen and (max-width: 1000px) {
    .show {
      top: -2px;
      opacity: 1;
    }
    .header-buttons {
      display: none;
    }

    .navbar__desktop {
      display: none;
    }
    .mobile-button {
      display: block;
    }
  }
`;
